import { RadialProgress } from '../radial-progress'

export interface StepRemainingTimeProps {
  startedAtMs: number
  estimatedTimeMs: number
  svgContainerClassName?: string
}

export const StepRemainingTime = ({
  startedAtMs,
  estimatedTimeMs,
  svgContainerClassName,
}: StepRemainingTimeProps) => {
  return (
    <div className='relative z-20 size-6'>
      <div className='absolute top-0 left-0 h-full w-full'>
        <RadialProgress
          animated
          startTime={startedAtMs}
          endTime={estimatedTimeMs}
          strokeWidth={4}
          progressClasses='-scale-y-100'
          circleClasses='text-accent-primary'
          svgClasses={svgContainerClassName}
        />
      </div>
    </div>
  )
}
